export default "__VITE_ASSET__DEONj_gn__"